"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataDogLogger = void 0;
var nucleus_logging_1 = require("@cvent/nucleus-logging");
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var transformers_1 = require("../transformers");
var rudderstack_1 = require("./rudderstack");
var userIdAttributeName = 'ddUserId';
/**
 * The DataDog logger sends metrics to data dog as custom actions. This assumes
 * datadog is configured via the standard nx integration.
 *
 * Note: This reporter checks if consumers pass a ddUserId property in the data. This is
 * useful to identify user session. More information can be found in the link below
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#identify-user-sessions
 */
var DATADOG_LOG = new nucleus_logging_1.Logger('DataDogLogReporter');
var dataDogLogger = function (id, data, options, callback) {
    var destinations = (data || {}).destinations;
    // If the metric has destinations, and datadog is not one of them, skip
    if ((destinations && Array.isArray(destinations) && !destinations.includes(constants_1.METRICS_DESTINATIONS.DATA_DOG)) ||
        (options && options.status === rudderstack_1.ACTION_STATUS_RETIRED)) {
        return;
    }
    if ((0, utils_1.getDatadogRumInstance)()) {
        try {
            var finalData_1;
            if (data) {
                // Check for fieldMappings and apply transformation if any
                finalData_1 = (0, transformers_1.transformPropertiesWithFieldMappings)(data, options);
                if (id === 'page_load') {
                    var prefix = (0, transformers_1.shouldSkipDefaultPrefix)(options) ? '' : undefined;
                    // Add the custom data collected by usePageActions API and add it as customAttributes to the DD View
                    // we doing this so that page_load data such as duration, result etc are set as global properties so that we can
                    // query the views with the same filer as actions in DD RUM
                    (0, utils_1.addContextAttributes)(data, prefix);
                }
                else {
                    (0, utils_1.removePreviousContextAttributes)();
                }
                finalData_1 = (0, transformers_1.transformAndValidateData)(data, [userIdAttributeName], options);
                if (finalData_1 === null || finalData_1 === void 0 ? void 0 : finalData_1.hasOwnProperty(userIdAttributeName)) {
                    (0, utils_1.getDatadogRumInstance)().setUser({ id: finalData_1[userIdAttributeName] });
                }
            }
            // Keys without prefix are the source of truth for the actual values. This is so that we allow consumer to override base props if needed
            if (finalData_1) {
                Object.keys(finalData_1).forEach(function (prop) {
                    if (/cvent_/i.test(prop)) {
                        var keyWithoutPrefix = prop.replace('cvent_', '');
                        var propValue = finalData_1[keyWithoutPrefix] || finalData_1[prop];
                        finalData_1[prop] = propValue;
                    }
                });
            }
            // If result is an error, treat it as such in DD
            var result = (finalData_1 || { result: 'success' }).result;
            if (result === 'error') {
                // Add error to the DD View
                (0, utils_1.getDatadogRumInstance)().addError(finalData_1.error_message || 'Unknown error', finalData_1);
            }
            var actionPayload = { id: id, data: finalData_1, options: options };
            (0, utils_1.getDatadogRumInstance)().addAction(id, finalData_1);
            DATADOG_LOG.debug('Action sent to datadog RUM >>>>>', JSON.stringify(actionPayload));
            if (callback)
                callback('datadogReporter', actionPayload);
        }
        catch (error) {
            DATADOG_LOG.error(error.message);
        }
    }
    else {
        DATADOG_LOG.error("DataDog RUM was never initialized. Therefore ".concat(id, " action was not sent >>>>"), data);
    }
};
exports.dataDogLogger = dataDogLogger;
